import e from "js-cookie";
import { addDays as s } from "date-fns";
const i = "notify", c = 30;
function E(o, t) {
  const n = `${import.meta.env.VITE_URL_BASE ? `.${import.meta.env.VITE_URL_BASE}` : "coactive.vagrant.switchsys.dev"}`, r = `${i}-${t}`, a = {
    path: "/",
    domain: n,
    sameSite: "Strict",
    expires: s(/* @__PURE__ */ new Date(), c),
    secure: !0
  };
  return e.set(r, o, a);
}
function _(o) {
  return e.get(`${i}-${o}`);
}
function v(o) {
  const t = `${import.meta.env.VITE_URL_BASE ? `.${import.meta.env.VITE_URL_BASE}` : "coactive.vagrant.switchsys.dev"}`;
  return e.remove(`${i}-${o}`, {
    domain: t
  });
}
export {
  _ as g,
  v as r,
  E as s
};
